/* -------------------------------------------------------------------------- */
/* STRING UTILS                                                               */
/* -------------------------------------------------------------------------- */

/**
 * Convert snake case to camel case
 *
 * @param {string} str
 * @returns {string}
 */
export const snakeToCamel = (str: string): string => str.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''));

/**
 * Clear text and upper case
 *
 * @param {string} text
 * @returns {string}
 */
export const clearAndUpper = (text: string): string => text.replace(/-/, '').toUpperCase();

/**
 * Convert string to pascal case
 *
 * @param {string} text
 * @returns {string}
 */
export const toPascalCase = (text: string): string => text.replace(/(^\w|-|_\w)/g, clearAndUpper).replace(/-/, '').replace(/_/, '');
